document.querySelector(".apdev_popup-btn").addEventListener(
  "click",
  function (e) {
    e.stopPropagation();
    document.querySelector(".apdev_popup").style.display = "block";
    document.querySelector("body").classList.add("apdev_popup_sizeguide_open");
  },
  false
);
document.querySelector(".apdev_popup-btn").addEventListener(
  "click",
  function () {
    document.querySelector(".apdev_popup-overlay").style.display = "block";
  },
  false
);
document.querySelector(".apdev_popup-close").addEventListener(
  "click",
  function () {
    document.querySelector(".apdev_popup").style.display = "none";
    document.querySelector(".apdev_popup-overlay").style.display = "none";
    document.querySelector("body").classList.remove("apdev_popup_sizeguide_open");
  },
  false
);
document.querySelector("body").addEventListener(
  "click",
  function () {
    document.querySelector(".apdev_popup").style.display = "none";
    document.querySelector(".apdev_popup-overlay").style.display = "none";
    document.querySelector("body").classList.remove("apdev_popup_sizeguide_open");
  },
  false
);
document.querySelector(".apdev_popup").addEventListener(
  "click",
  function (e) {
    e.stopPropagation();
  },
  false
);

checkIfFileExists();

function checkIfFileExists(){
    var apdev_popup_sizeguide_image = document.getElementById("apdev_popup_sizeguide_image").src;
    
    var http = new XMLHttpRequest();
    http.open('HEAD', apdev_popup_sizeguide_image, false);
    http.send();
    if(http.status==404){
      console.log(apdev_popup_sizeguide_image+' - sizeguide non trovata');
      document.getElementById("apdev_popup_sizeguide_image").src="https://cdn.shopify.com/s/files/1/0628/3293/5154/files/23.stringa_moma-04.png?v=1655303948";      
    }
}
